import React, { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import Text from "@amzn/meridian/text";
import { getFormattedTime } from "./util/Util";
import { PropTypes } from "prop-types";

/**
 * React component for getting the last refresh time in a page
 * @param deps
 * @param intl
 * @param lastUpdated
 * @return JSX.Element
 */
const RefreshTimer = ({ deps, intl, lastUpdated }) => {
  const [latestRefreshTime, setRefreshTime] = useState("");
  useEffect(() => {
    if (lastUpdated === null) setRefreshTime("");
    else if (lastUpdated !== undefined)
      setRefreshTime(getFormattedTime(new Date(lastUpdated), intl.locale));
    else setRefreshTime(getFormattedTime(new Date(), intl.locale));
  }, deps);

  return (
    <Text type="b200">
      <FormattedMessage
        id="common.data_last_updated"
        defaultMessage="Data last updated"
      />
      : {latestRefreshTime}
    </Text>
  );
};

RefreshTimer.propTypes = {
  deps: PropTypes.array,
  intl: PropTypes.string,
};

export default injectIntl(RefreshTimer);



// WEBPACK FOOTER //
// ./src/components/RefreshTimer.js